import { loadStripe } from "@stripe/stripe-js";

export default (config = {}) => ({
    // Initialize properties from config parameter
    errorMessage: "",
    apikey: config.apikey || "",
    pricekey: config.pricekey || "",
    callbacksuccess: config.callbacksuccess || "https://dezentrum.ch/success",
    callbackcancel: config.callbackcancel || "https://dezentrum.ch/cancelled",
    mode: config.mode || "subscription",
    stripe: null,

    async init() {
        if (this.apikey) {
            try {
                this.stripe = await loadStripe(this.apikey);
                console.log("Stripe initialized");
            } catch (error) {
                console.error("Failed to initialize Stripe:", error);
                this.errorMessage = "Failed to initialize payment system";
            }
        }
    },

    async checkout() {
        if (!this.stripe) {
            this.errorMessage = "Payment system is not initialized";
            return;
        }

        try {
            const result = await this.stripe.redirectToCheckout({
                lineItems: [{ price: this.pricekey, quantity: 1 }],
                mode: this.mode,
                successUrl: this.callbacksuccess,
                cancelUrl: this.callbackcancel,
            });

            if (result?.error) {
                this.errorMessage = result.error.message;
            }
        } catch (error) {
            this.errorMessage =
                error.message || "An error occurred during checkout";
        }
    },
});
